export { NileOtpInput } from './nile-otp-input';
